import { Component, Inject } from '@angular/core';
import { NZ_MODAL_DATA } from 'ng-zorro-antd/modal';
import { CondoUser } from '@api/model/condo-user';
import { UserService } from '@api/service/user.service';
import { NzModalService } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-modal-reset-user-password',
  templateUrl: './modal-reset-user-password.component.html',
  styleUrls: ['./modal-reset-user-password.component.scss']
})
export class ModalResetUserPasswordComponent {
  user: CondoUser;
  isLoadingOne = false;
  resetPasswordStatus: string;
  newPassword: number;

  constructor(
    private userService: UserService,
    private ModalService: NzModalService,
    @Inject(NZ_MODAL_DATA) data: { user: CondoUser }
  ) {
    this.user = data.user;
    this.resetPasswordStatus = '';
    this.newPassword = 0;
  }

  resetUserPassword(): void {
    this.userService.resetPassword(this.user?._id).subscribe({
      next: res => {
        (this.newPassword = res.password), (this.resetPasswordStatus = 'success');
      },
      error: error => {
        this.resetPasswordStatus = 'error';
      }
    });
  }

  loadOne(): void {
    this.isLoadingOne = true;
    setTimeout(() => {
      this.isLoadingOne = false;
    }, 2000);
  }
}
